import { render } from "./Footer.vue?vue&type=template&id=09280bf9&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=09280bf9&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09280bf9"]])

export default __exports__